import React, { useCallback } from 'react';

import TitleSplit from './TitleSplit';

interface Props {
    text: string;
    className: string;
}

const Title = (props: Props) => {
    const isLongText = useCallback(() => {
        return props.text && props.text.length >= 25;
    }, [props.text]);

    return isLongText() ? (
        <TitleSplit className={props.className} text={props.text} />
    ) : (
        <span className={props.className} dangerouslySetInnerHTML={{ __html: props.text }}></span>
    );
};

export default Title;
